import React, {Component} from "react";
import '../EMR.css';
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import AsyncSelect from "react-select/async";
import RemotingService from "../../../../services/remoting-service/RemotingService";
import Select from "react-select";
import LevelEnum from "./enums/LevelEnum";
import TypeEnum from "./enums/TypeEnum";
import BillTypeEnum from "./enums/BillTypeEnum";
import Button from "react-bootstrap/Button";
import AuthService from "../../../../services/auth-service/AuthService";
import DateUtil from "../../../../utils/DateUtil";
import AddButton from "../common/table/AddButton";
import RemoveButton from "../common/table/RemoveButton";
import NotificationService from "../../../../services/notification-service/NotificationService";
import RedAsterisk from "../../../../components/asterisk/RedAsterisk";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";

export default class ActiveDiagnosisTab extends Component {

    initialState = {
        activeKey: 0,
        previousSelected: [],
        icd10Code: null,
        level: null,
        type: null,
        billType: null
    }

    constructor(props) {
        super(props);
        this.MINIMUM_SEARCH_LENGTH = 2;
        this.repeatedItems = new WeakSet();
        this.assignAllDiagnosis();

        const user = AuthService.getUser();
        this.isProvider = ["DOCTOR", "THERAPIST"].includes(user.type);
        this.isNurse = "NURSE" === user.type;
        this.isClinicalStaff = this.isProvider || this.isNurse;

        let isNewComplaintOrNewPatient = this.props.visits[this.props.currentVisitIndex].appointmentType === "NEW_COMPLAINT" ||
            this.props.visits[this.props.currentVisitIndex].appointmentType === "NEW_PATIENT";

        this.initialState = {
            ...this.initialState,
            billType: this.props.isDirectBilling ? "DIRECT_BILLING" : "SELF_PAY",
            level: isNewComplaintOrNewPatient ? "PRINCIPAL" : null,
            type: isNewComplaintOrNewPatient ? "FINAL" : null
        }

        this.state = {
            ...this.initialState
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selectedVisitIndex !== this.props.selectedVisitIndex) {
            this.setState({previousSelected: []});
        }
    }

    assignAllDiagnosis() {
        this.allDiagnosis = [];
        for (let i = 0; i < this.props.visits.length; i++) {
            let visit = this.props.visits[i];
            visit.diagnosis.diagnosisGroups.forEach((dg) => {
                Array.prototype.push.apply(this.allDiagnosis, dg.diagnosisItems);
            });
        }
    }

    getPreviousDiagnosis() {
        const selectedVisitIndex = this.props.selectedVisitIndex !== undefined ? this.props.selectedVisitIndex : this.props.currentVisitIndex;
        const previousDiagnosis = [];

        // Show all diagnoses from visits BEFORE the selected visit
        for (let visitIndex = selectedVisitIndex - 1; visitIndex >= 0; visitIndex--) {
            const visit = this.props.visits[visitIndex];

            if (visit.diagnosis && visit.diagnosis.diagnosisGroups) {
                visit.diagnosis.diagnosisGroups.forEach((dg) => {
                    if (dg.diagnosisItems) {
                        dg.diagnosisItems.forEach((diagnosisItem) => {
                            const diagnosisWithVisitInfo = {
                                ...diagnosisItem,
                                visitIndex: visitIndex
                            };
                            previousDiagnosis.push(diagnosisWithVisitInfo);
                        });
                    }
                });
            }
        }

        return previousDiagnosis;
    }

    appendDiagnosisItem(diagnosisItem) {
        const targetGroup = this.props.diagnosis.diagnosisGroups[this.state.activeKey];
        if (targetGroup.diagnosisItems.some(item => item.code === diagnosisItem.code)) {
            NotificationService.showNotification({
                severity: 'warn',
                summary: 'Warning',
                detail: 'This diagnosis code is already in the list.'
            });
            return;
        }
        targetGroup.diagnosisItems.push(diagnosisItem);
    }


    render() {
        let diagnosisGroups = this.props.diagnosis.diagnosisGroups;
        const isDirectBilling = this.props.isDirectBilling;
        let tabs = [];

        if (diagnosisGroups.length == 0) {
            diagnosisGroups.push({diagnosisItems: []});
        }

        diagnosisGroups.forEach((diagnosisGroup, index) => {
            tabs.push(
                <Tab key={index} eventKey={index} title={
                    <div style={{display: "flex"}}>
                        {this.getDiagnosisGroupTitle(diagnosisGroup)}&nbsp;
                        <RemoveButton
                            onClick={() => {
                                const items = diagnosisGroup.diagnosisItems || [];
                                const dbItems = this.isClinicalStaff
                                    ? items.filter(item => BillTypeEnum[item.billType] === BillTypeEnum.DIRECT_BILLING)
                                    : [];

                                if (dbItems.length === 0) {
                                    diagnosisGroups.splice(index, 1);
                                    this.forceUpdate();
                                    return;
                                }

                                if (dbItems.length === items.length) {
                                    NotificationService.showNotification({
                                        severity: 'warn',
                                        summary: 'Warning',
                                        detail: 'Direct Billing diagnoses cannot be removed.'
                                    });
                                    return;
                                }

                                diagnosisGroup.diagnosisItems = dbItems;
                                this.forceUpdate();
                            }}/>
                    </div>
                }>
                    {this.activeDiagnosisTable(diagnosisGroup, isDirectBilling)}
                </Tab>
            );
        });

        tabs.push(
            <Tab key={"+"} eventKey={"+"} title={"+"}>
            </Tab>
        );

        return (
            <div>
                <div className="content-label">Diagnosis <RedAsterisk renderForAllTypes/></div>
                <Tabs activeKey={this.state.activeKey}
                      id="emr-tabs"
                      style={{fontSize: "12px"}}
                      onSelect={(tabName) => {
                          if (tabName == "+") {
                              diagnosisGroups.push({diagnosisItems: []});
                              let activeTab = diagnosisGroups.length - 1;
                              this.setState({activeKey: activeTab})
                          } else {
                              this.setState({activeKey: tabName})
                          }
                      }}>
                    {tabs}
                </Tabs>

                <br/>
                <br/>

                <div style={{pointerEvents: 'auto'}}>
                    <div style={{display: "flex"}}>
                        <div className="content-label" style={{margin: "auto", marginLeft: "0px"}}>Previous Diagnosis</div>
                        <Button variant="outline-secondary"
                                size="sm"
                                disabled={isDirectBilling || this.props.disabled}
                                onClick={() => {
                                    if (this.state.previousSelected.length == 0) {
                                        return;
                                    }

                                    const copies = this.state.previousSelected.map((selectedDiagnosis) => {
                                        let copied = Object.assign({}, selectedDiagnosis);
                                        copied.provider = AuthService.getUser().name;
                                        copied.visitDate = new Date();
                                        copied.id = null;
                                        delete copied.visitIndex;
                                        if (copied.type == null) {
                                            copied.type = 'FINAL';
                                        }
                                        return copied;
                                    });

                                    // Force exactly one principal in the target group.
                                    const targetGroup = this.props.diagnosis.diagnosisGroups[this.state.activeKey];
                                    const hasExistingPrincipal = (targetGroup?.diagnosisItems || [])
                                        .some(item => item.level === 'PRINCIPAL');

                                    let principalCopy = null;
                                    if (!hasExistingPrincipal) {
                                        principalCopy = copies.find(c => c.level === 'PRINCIPAL') || copies[0];
                                    }
                                    copies.forEach((copied) => {
                                        copied.level = (copied === principalCopy) ? 'PRINCIPAL' : 'SECONDARY';
                                    });

                                    copies.forEach((copied) => {
                                        this.repeatedItems.add(copied);
                                        this.appendDiagnosisItem(copied);
                                    });
                                    this.setState({previousSelected: []});
                                }}>
                            Repeat Selected
                        </Button>
                    </div>

                    {this.previousDiagnosisTable()}
                </div>
            </div>
        );
    }

    activeDiagnosisTable(diagnosisGroup, directBilling) {
        const hasPrincipal = diagnosisGroup.diagnosisItems != null &&
            diagnosisGroup.diagnosisItems.some(item => item.level === 'PRINCIPAL');
        const diagnosisLevelOptions = LevelEnum.toArray().filter(level => {
                if (hasPrincipal && level.key === 'PRINCIPAL') return false;
                if (this.props.isDirectBilling && this.isProvider && level.key === 'PRINCIPAL') return false;
                return true;
            }).map(v => ({value: v.key, label: v.name}));
        // Nullify pre-selected 'PRINCIPAL' state if a principal already exists in this tab (e.g. on data load for new complaint visits)
        const effectiveLevel = (this.state.level === 'PRINCIPAL' && hasPrincipal) ? null : this.state.level;
        const currentVisit = this.props.visits[this.props.currentVisitIndex];
        return (
            <div className={"content-card"}>
                <table className={"emr-table"}>
                    <tbody>
                    <tr>
                        <th>ICD</th>
                        <th>Description</th>
                        <th style={{width: 100}}>Level</th>
                        <th style={{width: 120}}>Type</th>
                        <th style={{color: "red"}}>ⓧ</th>
                    </tr>
                    {(diagnosisGroup.diagnosisItems == null || diagnosisGroup.diagnosisItems.length == 0) ? null :
                        diagnosisGroup.diagnosisItems.map((diagnosisItem, diagnosisItemIndex) => {
                            return (
                                <tr key={"activeDiagnosisTab" + diagnosisItemIndex} style={{backgroundColor: "white"}}>
                                    <td>{diagnosisItem.code}</td>
                                    <td>{diagnosisItem.description}</td>
                                    <td>
                                        {(this.repeatedItems.has(diagnosisItem) || diagnosisItem.level == null) ? (
                                            <Select
                                                className={"emr-in-table-select-container"}
                                                classNamePrefix={"emr-in-table-select"}
                                                value={diagnosisItem.level != null
                                                    ? {value: diagnosisItem.level, label: LevelEnum[diagnosisItem.level].name}
                                                    : null}
                                                onChange={(event) => {
                                                    diagnosisItem.level = event.value;
                                                    this.forceUpdate();
                                                }}
                                                options={diagnosisLevelOptions}
                                            />
                                        ) : LevelEnum[diagnosisItem.level].name}
                                    </td>
                                    <td>
                                        {(this.repeatedItems.has(diagnosisItem) || diagnosisItem.type == null) ? (
                                            <Select
                                                className={"emr-in-table-select-container"}
                                                classNamePrefix={"emr-in-table-select"}
                                                value={diagnosisItem.type != null
                                                    ? {value: diagnosisItem.type, label: TypeEnum[diagnosisItem.type].name}
                                                    : null}
                                                onChange={(event) => {
                                                    diagnosisItem.type = event.value;
                                                    this.forceUpdate();
                                                }}
                                                options={TypeEnum.toArray().map(v => ({value: v.key, label: v.name}))}
                                            />
                                        ) : TypeEnum[diagnosisItem.type].name}
                                    </td>
                                    <td>
                                        {(!this.isClinicalStaff || BillTypeEnum[diagnosisItem.billType] !== BillTypeEnum.DIRECT_BILLING) &&
                                            <RemoveButton
                                                onClick={() => {
                                                    diagnosisGroup.diagnosisItems.splice(diagnosisItemIndex, 1);
                                                    this.forceUpdate();
                                                }}
                                            />
                                        }
                                    </td>
                                </tr>
                            )
                        })
                    }
                    <tr style={{backgroundColor: "white"}}>
                        <td style={{minWidth: "80px"}}>
                            <AsyncSelect
                                className={"emr-in-table-select-container"}
                                classNamePrefix={"emr-in-table-select"}
                                noOptionsMessage={this.noOptionsMessage.bind(this)}
                                loadOptions={this.loadICD10CodesByCode}
                                value={this.state.icd10Code != null ?
                                    {
                                        value: this.state.icd10Code,
                                        label: this.state.icd10Code.code
                                    } : null}
                                onChange={(event) => {
                                    this.setState({icd10Code: event.value});
                                }}
                            />
                        </td>
                        <td>
                            <AsyncSelect
                                className={"emr-in-table-select-container"}
                                classNamePrefix={"emr-in-table-select"}
                                noOptionsMessage={this.noOptionsMessage.bind(this)}
                                loadOptions={this.loadICD10CodesByDescription}
                                value={this.state.icd10Code != null ?
                                    {
                                        value: this.state.icd10Code,
                                        label: this.state.icd10Code.description
                                    } : null}
                                onChange={(event) => {
                                    this.setState({icd10Code: event.value});
                                }}
                            />
                        </td>
                        <td>
                            <Select
                                className={"emr-in-table-select-container"}
                                classNamePrefix={"emr-in-table-select"}
                                value={effectiveLevel != null ?
                                    {
                                        value: effectiveLevel,
                                        label: LevelEnum[effectiveLevel].name
                                    } : null}
                                onChange={(event) => {
                                    this.setState({level: event.value});
                                }}
                                options={diagnosisLevelOptions}
                            />
                        </td>
                        <td>
                            <Select
                                className={"emr-in-table-select-container"}
                                classNamePrefix={"emr-in-table-select"}
                                value={this.state.type != null ?
                                    {
                                        value: this.state.type,
                                        label: TypeEnum[this.state.type].name
                                    } : null}
                                onChange={(event) => {
                                    this.setState({type: event.value});
                                }}
                                options={TypeEnum.toArray().map(v => {
                                        return {value: v.key, label: v.name}
                                    }
                                )}
                            />
                        </td>
                        <td>
                            <AddButton
                                onClick={() => {
                                    if (diagnosisGroup.diagnosisItems == null) {
                                        diagnosisGroup.diagnosisItems = [];
                                    }
                                    if (directBilling && (
                                        this.allDiagnosis.find(item => item.code === this.state.icd10Code?.code) ||
                                        diagnosisGroup.diagnosisItems.find(item => item.code === this.state.icd10Code?.code)
                                    )) {
                                        NotificationService.showNotification({
                                            severity: 'warn',
                                            summary: 'Warning',
                                            detail: 'Diagnosis code is already selected for the direct billing visit'
                                        });
                                        return;
                                    }
                                    this.appendDiagnosisItem(
                                        {
                                            code: this.state.icd10Code != null ? this.state.icd10Code.code : null,
                                            description: this.state.icd10Code != null ? this.state.icd10Code.description : null,
                                            level: effectiveLevel,
                                            type: this.state.type,
                                            billType: this.state.billType,
                                            provider: this.isNurse ? currentVisit.appointment.staff.name : AuthService.getUser().name,
                                            visitDate: new Date()
                                        }
                                    );
                                    const principalNowExists = diagnosisGroup.diagnosisItems.some(item => item.level === 'PRINCIPAL');
                                    const nextLevel = (this.initialState.level === 'PRINCIPAL' && principalNowExists) ? null : this.initialState.level;
                                    this.setState({
                                        icd10Code: this.initialState.icd10Code,
                                        level: nextLevel,
                                        type: this.initialState.type,
                                        billType: this.initialState.billType
                                    });
                                }}
                                disabled={!this.state.icd10Code || !effectiveLevel || !this.state.type}
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    getDiagnosisGroupTitle(diagnosisGroup) {
        if (diagnosisGroup.diagnosisItems == null || diagnosisGroup.diagnosisItems.length == 0) {
            return "\<Add a principal\>";
        }
        let principal = diagnosisGroup.diagnosisItems.find(i => i.level == "PRINCIPAL");
        return principal == null ? "\<Add a principal\>" : principal.description;
    }

    previousDiagnosisTable() {
        const allPreviousDiagnosis = this.getPreviousDiagnosis();

        if (allPreviousDiagnosis == null || allPreviousDiagnosis.length == 0) {
            return "No previous diagnosis";
        }

        const diagnosisWithDisplayInfo = allPreviousDiagnosis.map((diagnosisItem, index) => {
            const visit = this.props.visits[diagnosisItem.visitIndex];
            return {
                ...diagnosisItem,
                uniqueKey: `${diagnosisItem.visitIndex}-${index}`, // Generate unique key for DataTable selection
                displayDate: diagnosisItem.visitDate || visit.appointment.startTime,
                displayProvider: diagnosisItem.provider || visit.appointment.staff.name
            };
        });

        return (
            <div className={"content-card"}>
                <DataTable
                    value={diagnosisWithDisplayInfo}
                    paginator={true}
                    rows={5}
                    paginatorPosition="bottom"
                    rowHover={true}
                    selection={this.state.previousSelected}
                    onSelectionChange={(e) => this.setState({previousSelected: e.value})}
                    selectionMode="multiple"
                    metaKeySelection={false}
                    dataKey="uniqueKey"
                    className="p-datatable-sm">
                    
                    <Column selectionMode="multiple" style={{width: "40px"}} />
                    <Column field="displayDate" header="Visit Date" 
                            body={(rowData) => DateUtil.formatDate(rowData.displayDate)}
                            style={{width: "120px"}} />
                    <Column field="displayProvider" header="Provider" style={{width: "120px"}} />
                    <Column field="description" header="Diagnosis Name" />
                    <Column field="code" header="ICD" style={{width: "80px"}} />
                    <Column field="level" header="Level" 
                            body={(rowData) => rowData.level != null ? LevelEnum[rowData.level].name : ""}
                            style={{width: "80px"}} />
                    <Column field="type" header="Type"
                            body={(rowData) => rowData.type != null ? TypeEnum[rowData.type].name : ""}
                            style={{width: "80px"}} />
                </DataTable>
            </div>
        );
    }

    loadICD10CodesByCode = (inputValue, callback) => {
        if (inputValue.length < this.MINIMUM_SEARCH_LENGTH) {
            return callback(null);
        }
        RemotingService.getRemoteCall('api/icd10/code/' + inputValue, null, (response) => {
            if (response == null || response.length == 0) {
                return callback(null);
            }
            let options = response.map(r => {
                return {value: r, label: r.code}
            });
            return callback(options);
        });
    }

    loadICD10CodesByDescription = (inputValue, callback) => {
        if (inputValue.length < this.MINIMUM_SEARCH_LENGTH) {
            return callback(null);
        }
        RemotingService.getRemoteCall('api/icd10/description/' + inputValue, null, (response) => {
            if (response == null || response.length == 0) {
                return callback(null);
            }
            let options = response.map(r => {
                return {value: r, label: r.description}
            });
            return callback(options);
        });
    }

    noOptionsMessage(input) {
        if (input.inputValue == null || input.inputValue.length < this.MINIMUM_SEARCH_LENGTH) {
            return <div>Type {this.MINIMUM_SEARCH_LENGTH} characters</div>;
        } else {
            return <div>No options</div>;
        }
    }
}
